<template>
    <div class="w-full px-3 mt-6 mb-5 text-left">
        <label
            v-if="label"
            class="block my-2 mt-4 mb-4 text-sm font-normal leading-5 tracking-wide text-gray-600 sm:font-normal sm:text-base sm:leading-10"
            >{{ label }}</label
        >
        <div class="w-full sm:mt-0 sm:col-span-2">
            <div class="relative rounded-md shadow-sm">
                <textarea
                    :value="value"
                    @input="updateValue"
                    v-bind="$attrs"
                    v-on="listeners"
                    id="first_name"
                    class="block w-full h-48 p-4 transition duration-150 ease-in-out border-b-2 sm:text-base sm:leading-5 "
                    :class="[hasError ? errorClass : activeClass, Addclass]"
                    :placeholder="placeholder"
                ></textarea>
                <div
                    class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none"
                    v-if="hasError"
                >
                    <svg
                        class="w-5 h-5 text-red-500"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                    >
                        <path
                            fill-rule="evenodd"
                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                            clip-rule="evenodd"
                        />
                    </svg>
                </div>
            </div>
            <p v-if="hasError" class="mt-2 text-sm text-red-600">
                {{ errorMessage }}
            </p>
        </div>
    </div>
</template>

<script>
import { formFieldMixin } from "../mixins/formFieldMixin";
export default {
    mixins: [formFieldMixin],
    props: {
        label: {
            type: String
        },
        Addclass: {
            type: String,
            default: ""
        },
        placeholder: {
            type: String,
            required: true
        },

        hasError: {
            type: Boolean,
            default: false
        },
        errorMessage: {
            type: String
        }
    },
    computed: {
        listeners() {
            return {
                ...this.$listeners,
                input: this.updateValue
            };
        }
    },
    data() {
        return {
            errorClass:
                " border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus:shadow-outline-red ",
            activeClass: "border-gray-500"
        };
    }
};
</script>

<style></style>
